<script lang="ts">
  import { onMount, onDestroy } from 'svelte';
  import { createEventDispatcher } from 'svelte';

  export let endTime: number;

  const dispatch = createEventDispatcher();

  let currentTime = Math.floor(Date.now() / 1000);
  let intervalId: ReturnType<typeof setInterval>;

  $: timeDiff = Math.max(0, endTime - currentTime);
  $: hours = Math.floor(timeDiff / 3600);
  $: minutes = Math.floor((timeDiff % 3600) / 60);
  $: seconds = timeDiff % 60;

  $: if (timeDiff === 0) {
    dispatch('expired');
  }

  onMount(() => {
    intervalId = setInterval(() => {
      currentTime = Math.floor(Date.now() / 1000);
    }, 1000);
  });

  onDestroy(() => {
    if (intervalId) {
      clearInterval(intervalId);
    }
  });
</script>

<div
  class="text-md text-center px-4 py-2.5 sm:px-3.5 items-center flex justify-center gap-1 bg-primary-500 text-white h-[48px]"
>
  Hurry! Limited offer ends soon <span class="font-semibold"
    >{hours.toString().padStart(2, '0')}:{minutes.toString().padStart(2, '0')}:{seconds
      .toString()
      .padStart(2, '0')}</span
  >
</div>
